<template>
  <div>
    <div class="animated fadeIn">
      <b-row class="mt-1">
        <b-col sm="12">
          <div class="brand-card">
            <b-row>
              <b-col sm="12" class="text-center" style="margin-top: 30px;">
                <h2 v-if="!isMobileScreen" class="text-info">Ganhe dias de acesso e Sleekers sem pagar nada usando nosso programa de indicação!</h2>
                <h5 style="margin-left: 20px; margin-right: 20px;" v-else class="text-info">Ganhe dias de acesso e Sleekers sem pagar nada usando nosso programa de indicação!</h5>
                <b-row  style="margin-top: 50px;">
                  <b-col sm="10" offset="1">
                    <b-row v-if="!isMobileScreen">
                      <b-col xs="4">
                        <img src="/img/club-1.png" style="max-width: 65px;"/>
                        <h4 style="margin-top: 50px;">Indique</h4>
                      </b-col>
                      <b-col xs="4" class="m-t">
                        <img src="/img/club-2.png" style="max-width: 65px;"/>
                        <h4 style="margin-top: 30px;">Pontue</h4>
                      </b-col>
                      <b-col xs="4" class="m-t">
                        <img src="/img/club-3.png" style="max-width: 65px;"/>
                        <h4 style="margin-top: 30px;">Troque</h4>
                      </b-col>
                    </b-row>
                    <b-row v-else>
                      <b-col xs="4" style="margin-top: 20px; margin-left: -15px;">
                        <img src="/img/club-1.png" style="max-width: 40px;"/>
                        <p style="margin-top: 30px;">Indique</p>
                      </b-col>
                      <b-col xs="4" class="m-t">
                        <img src="/img/club-2.png" style="max-width: 40px;"/>
                        <p style="margin-top: 30px;">Pontue</p>
                      </b-col>
                      <b-col xs="4" class="m-t">
                        <img src="/img/club-3.png" style="max-width: 40px;"/>
                        <p style="margin-top: 30px;">Troque</p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <div class="brand-card-body text-white" style="background-color: #30353b;" v-bind:class="{'tamanho-fora': !isMobileScreen}">
              <b-col sm="8" offset-sm="2">
                <div class="text-uppercase">
                    <br/>
                    <h3 v-if="points">Você tem <b>{{points}}</b> pontos.</h3>
                    <h3 v-else>Você ainda não tem pontos.</h3><br/>
                </div>
                <div class="text-uppercase">
                    <br/>
                    <p>Se seu amigo contratar...</p>
                </div>
                <b-row v-if="!isMobileScreen">
                  <b-col xs="3" v-for="(bonus, index) in bonuses" :key="index">
                    <h1><b><i>{{bonus.name}}</i></b></h1>
                    <h3 class="text-info">você ganha</h3>
                    <h1>{{bonus.points}} pontos</h1>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-col xs="3" v-for="(bonus, index) in bonuses" :key="index">
                    <p style="font-size: 90%;"><b><i>{{bonus.name}}</i></b></p>
                    <p style="font-size: 80%;" class="text-info">você<br/>ganha</p>
                    <p style="font-size: 90%;">{{bonus.points}}<br v-if="isMobileScreen" /> pontos</p>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <b-col class="bg-white text-center" sm="8" offset-sm="2">
            <!--<b-card header="<i class='fa fa-trophy'></i> Prêmios" v-if="items && items.length > 0">-->
              <b-table :dark="dark" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="captions" :current-page="currentPage" :per-page="perPage">
                <template #cell(points)="data">
                  <div>
                    {{data.item.points}} pontos
                  </div>
                </template>
                <template #cell(name)="data">
                  <div>
                    {{data.item.days}} dias e {{data.item.posts}} posts
                  </div>
                </template>
                <template #cell(actions)="data">
                  <div>
                    <b-button v-if="data.item.points <= points" variant="success" @click="useClubPoints(data.item.points)">Usar Pontos</b-button>
                    <b-button v-else disabled>Pontos Insuficientes</b-button>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col sm="12">
              <b-row>
                <b-col xs="6" v-bind:class="{'text-right': !isMobileScreen, 'text-center': isMobileScreen}">
                  <p>Comece a indicar amigos agora mesmo!</p>
                  <p><b>https://sleeker.pt/invite/{{invitationCode}}</b></p>
                </b-col>
                <b-col xs="6" v-bind:class="{'text-center': isMobileScreen}">
                  <b-button
                  v-clipboard:copy="'https://sleeker.pt/invite/' + invitationCode"
                  variant="info"
                  class="text-white">
                    <i class="fa fa-copy"></i> Copiar
                  </b-button>
                  <a
                  :href="'whatsapp://send?text=Oi! Queria te convidar para conhecer o Sleeker e ganhar postagens para as redes sociais! https://sleeker.pt/invite/' + invitationCode" 
                  v-clipboard:copy="'https://sleeker.pt/invite/' + invitationCode"
                  variant="success"
                  class="text-white btn btn-success">
                    <i class="fa fa-whatsapp"></i> Enviar no whatsapp
                  </a>
                </b-col>
              </b-row>
              <br/>
            </b-col>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import service from '../service'
import { isMobile } from "mobile-device-detect";

export default {
  name: 'Club',
  inheritAttrs: false,
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    },
    userId: undefined,
    admin: false
  },
  data: () => {
    return {
      currentPage: 1,
      fields: [
        {
          label: 'Pontos',
          key: "points"
        },
        {
          label: 'Bônus',
          key: "name"
        },
        {
          label: 'Ação',
          key: "actions"
        },
      ],
      prizes: [],
      points: 0,
      bonuses: [],
      invitationCode: "",
      isMobileScreen: isMobile
    }
  },
  computed: {
    items: function() {
      return this.prizes;
    },
    totalRows: function () { return this.getRowCount() },
    captions: function() { 

      let fields = this.fields;

      return fields 
    },
  },
  methods: {
    getPaymentBadge (paymentStatus) {
      return paymentStatus === 0 ? 'warning'
          : paymentStatus === 1 ? 'success'
            : paymentStatus === 2 ? 'danger' : 'primary'
    },
    getRowCount: function () {
      return this.items.length
    },
    getPrizes: function () {
      service.getClubData(this.userId).then(response => {
        this.prizes = response.prizes;
        this.bonuses = response.bonuses;
        this.points = response.points;
        this.invitationCode = response.invitationCode;
      });
    },
    useClubPoints: function(points) {
      service.reportError("Cliente pediu para usar pontos. - " + points).then(() => {
        alert("Seu pedido será processado em alguns minutos!");
      });
    }
  },
  created() {
    this.getPrizes();
  }
}
</script>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.m-t {
  margin-top: 20px !important;
}

.padder {
  padding: 40px !important;
}

.text-black {
  color: black !important;
}

.text-white {
  color: white !important;
}

.tamanho-fora {
  height: 300px !important;
}

.tamanho-dentro {
  height: 210px !important;
}
</style>